/* ==========================================================================
   I Fontanini — Custom JavaScript
   Loaded via custom.globals snippet.
   Keep under 16KB minified.
   ========================================================================== */

/* --------------------------------------------------------------------------
   0. FORM POST-SUBMIT SCROLL PRESERVATION
   Native Shopify forms redirect after submit; keep users where they submitted.
   -------------------------------------------------------------------------- */

(function() {
  var STORAGE_KEY = 'ifontanini:form-submit-scroll';
  var NEWSLETTER_PENDING_KEY = 'ifontanini:newsletter-submit-pending';
  var FORM_SELECTOR = '.contact-split__form, .pack-split__form, .site-footer__signup-form';
  var NEWSLETTER_FORM_SELECTOR = '.site-footer__signup-form';

  function hasQueryFlag(flag) {
    var search = window.location.search || '';
    return search.indexOf(flag + '=true') !== -1;
  }

  function hasSuccessParam() {
    return hasQueryFlag('contact_posted') || hasQueryFlag('customer_posted');
  }

  function stripFormActionHash(form) {
    var action = form.getAttribute('action');

    if (!action || action.indexOf('#') === -1) return;

    form.setAttribute('action', action.split('#')[0]);
  }

  function stripTrackedFormActionHashes() {
    document.querySelectorAll(FORM_SELECTOR).forEach(stripFormActionHash);
  }

  function hasPendingNewsletterSubmit() {
    try {
      return window.sessionStorage.getItem(NEWSLETTER_PENDING_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }

  function clearPendingNewsletterSubmit() {
    try {
      window.sessionStorage.removeItem(NEWSLETTER_PENDING_KEY);
    } catch (error) {
      return;
    }
  }

  function showNewsletterSuccessFallback() {
    if (!hasQueryFlag('customer_posted') && !hasPendingNewsletterSubmit()) return;

    var form = document.querySelector(NEWSLETTER_FORM_SELECTOR);
    if (!form) return;

    if (form.querySelector('.site-footer__signup-note')) {
      clearPendingNewsletterSubmit();
      return;
    }

    var note = document.createElement('p');
    note.className = 'site-footer__signup-note';
    note.setAttribute('role', 'status');
    note.setAttribute('tabindex', '-1');
    note.textContent = 'Ci sei!';

    form.appendChild(note);
    clearPendingNewsletterSubmit();
  }

  function saveScrollPosition(event) {
    var form = event.target;

    if (!form || !form.matches || !form.matches(FORM_SELECTOR)) return;

    stripFormActionHash(form);

    try {
      window.sessionStorage.setItem(STORAGE_KEY, String(window.scrollY || window.pageYOffset || 0));
      if (form.matches(NEWSLETTER_FORM_SELECTOR)) {
        window.sessionStorage.setItem(NEWSLETTER_PENDING_KEY, 'true');
      }
    } catch (error) {
      return;
    }
  }

  stripTrackedFormActionHashes();
  showNewsletterSuccessFallback();

  document.addEventListener('submit', saveScrollPosition, true);

  if (!hasSuccessParam()) {
    try {
      window.sessionStorage.removeItem(STORAGE_KEY);
    } catch (error) {
      return;
    }

    return;
  }

  try {
    var savedScroll = window.sessionStorage.getItem(STORAGE_KEY);
    if (savedScroll === null) return;

    window.sessionStorage.removeItem(STORAGE_KEY);

    var scrollY = parseInt(savedScroll, 10);
    if (Number.isNaN(scrollY)) return;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    window.requestAnimationFrame(function() {
      window.scrollTo(0, scrollY);
    });
  } catch (error) {
    return;
  }
}());

/* --------------------------------------------------------------------------
   1. INGREDIENT PILL FILTER (Phase 2)
   Filters collection products by tag using Shopify's native tag URL pattern.
   Navigates to /collections/{handle}/{tag} or back to /collections/{handle}.
   -------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function() {
  var filterContainer = document.querySelector('.ingredient-filter');
  if (!filterContainer) return;

  /* W-06: Sync active pill state from URL path.
     current_tags is unavailable in the custom-liquid render context,
     so we detect the active tag client-side from the URL instead. */
  var pathParts = window.location.pathname.split('/');
  var activeTag = pathParts.length >= 4 && pathParts[1] === 'collections'
    ? pathParts[pathParts.length - 1]
    : null;
  if (activeTag) {
    filterContainer.querySelectorAll('.ingredient-pill').forEach(function(pill) {
      if (pill.dataset.tag === activeTag) {
        pill.classList.add('active');
        pill.setAttribute('aria-pressed', 'true');
      }
    });
  }

  filterContainer.addEventListener('click', function(e) {
    var pill = e.target.closest('.ingredient-pill');
    if (!pill) return;

    var tag = pill.dataset.tag;
    var isActive = pill.getAttribute('aria-pressed') === 'true';
    var collectionUrl = pill.dataset.collectionUrl;

    /* W-05: guard against undefined dataset values */
    if (!tag || !collectionUrl) return;

    /* W-04: validate URL to prevent DOM-clobbering XSS */
    if (typeof collectionUrl !== 'string' || !collectionUrl.startsWith('/collections/')) return;
    if (typeof tag !== 'string' || !/^[a-z0-9\-]+$/i.test(tag)) return;

    if (isActive) {
      /* Remove filter — navigate to unfiltered collection */
      window.location.href = collectionUrl;
    } else {
      /* Apply filter — navigate to tagged collection URL */
      window.location.href = collectionUrl + '/' + tag;
    }
  });
});

/* --------------------------------------------------------------------------
   2. STICKY ADD-TO-CART VARIANT SCROLL (Phase 3, D-18, RESEARCH Pitfall 6)
   When the mobile sticky bar's add-to-cart button is tapped on a product that
   requires variant selection, scroll to the variant picker instead of letting
   the native handler fire a silent add-to-cart failure.

   Capture-phase listener — runs before native sticky-add-to-cart click handler.
   Host element sets [data-variant-available='true'] when a variant is picked.
   -------------------------------------------------------------------------- */

document.addEventListener('click', function (e) {
  var btn = e.target.closest('sticky-add-to-cart .add-to-cart-button, sticky-add-to-cart .sticky-add-to-cart__button');
  if (!btn) return;
  var host = btn.closest('sticky-add-to-cart');
  if (!host) return;
  var unavailable = host.dataset.variantAvailable === 'false'
    || btn.disabled
    || btn.getAttribute('aria-disabled') === 'true';
  if (unavailable) {
    e.preventDefault();
    e.stopPropagation();
    var picker = document.querySelector('variant-picker, .variant-picker, variant-main-picker');
    if (picker) {
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}, true);

/* --------------------------------------------------------------------------
   3. PRODUCT CARD V3 — buy interactions
   - "Scegli" (multi-variant) reveals an inline <select> + the cart button.
   - Selecting a variant updates the hidden id input and the displayed price.
   - The actual AJAX add + cart drawer are handled by Horizon's
     <product-form-component>; here we only add a success animation on
     the button when Horizon fires its cart:update event.
   -------------------------------------------------------------------------- */
(function () {
  function updatePriceFromSelect(buy) {
    var select = buy.querySelector('[data-pcard-select]');
    var price = buy.querySelector('[data-pcard-price]');
    if (!select || !price) return;
    var opt = select.options[select.selectedIndex];
    if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
  }

  /* variant change -> update id input + price */
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-pcard-select]');
    if (!select) return;
    var buy = select.closest('.pcard__buy');
    if (!buy) return;
    var opt = select.options[select.selectedIndex];
    var idInput = buy.querySelector('[data-pcard-id]');
    if (idInput && opt) idInput.value = opt.value;
    updatePriceFromSelect(buy);
    /* Sync the mobile format chip. The card image is deliberately NOT
       swapped: a variant's single Shopify image can't serve both the cesto
       and flacone views — variant images show as thumbnails in the format
       sheet instead (§5). */
    var card = buy.closest('.product-card');
    if (card && opt) {
      var chipLabel = card.querySelector('.pcard__format-chip-label');
      if (chipLabel) chipLabel.textContent = opt.text;
    }
    /* Pointer picks release focus so the ring doesn't linger on the field;
       keyboard interaction (arrow browsing, Enter) keeps focus intact. The
       last-interaction flag is set below on pointerdown / cleared on keydown. */
    if (select.dataset.pcardPointer) {
      delete select.dataset.pcardPointer;
      select.blur();
    }
  });

  /* Track how the select is being driven: pointer sets the flag, any key
     clears it (so arrow-key browsing never gets blurred mid-interaction). */
  document.addEventListener('pointerdown', function (e) {
    var select = e.target.closest && e.target.closest('[data-pcard-select]');
    if (select) select.dataset.pcardPointer = '1';
  }, true);
  document.addEventListener('keydown', function (e) {
    var select = e.target.closest && e.target.closest('[data-pcard-select]');
    if (select) delete select.dataset.pcardPointer;
  }, true);
  /* Note: the add-to-cart success animation is Horizon's native
     [data-added] checkmark burst (add-to-cart-button snippet) — no custom JS. */
})();

/* --------------------------------------------------------------------------
   4. (retired) CARD VIEW TOGGLE cesto/flacone — removed with its snippet
   (custom.view-toggle.liquid) and CSS; column density is Horizon's
   grid-density switcher (results-list.js), made instant for the custom theme.
   -------------------------------------------------------------------------- */

/* --------------------------------------------------------------------------
   5. FORMAT BOTTOM SHEET (mobile) — styles in custom.css §19
   Under 750px the cart button of a multi-format card opens a bottom sheet
   listing the formats (sourced from the hidden [data-pcard-select]); tapping
   a format sets the variant on the card's form and submits it, so Horizon's
   product-form-component does the AJAX add + cart drawer as usual.
   -------------------------------------------------------------------------- */
(function () {
  var sheet = null;
  var lastFocus = null;

  function ensureSheet() {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'pcard-sheet';
    sheet.hidden = true;
    var backdrop = document.createElement('div');
    backdrop.className = 'pcard-sheet__backdrop';
    var panel = document.createElement('div');
    panel.className = 'pcard-sheet__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Scegli il formato');
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'pcard-sheet__close';
    close.setAttribute('aria-label', 'Chiudi');
    close.textContent = '×';
    var title = document.createElement('p');
    title.className = 'pcard-sheet__title';
    title.textContent = 'Scegli il formato';
    var product = document.createElement('p');
    product.className = 'pcard-sheet__product';
    var options = document.createElement('div');
    options.className = 'pcard-sheet__options';
    panel.appendChild(close);
    panel.appendChild(title);
    panel.appendChild(product);
    panel.appendChild(options);
    sheet.appendChild(backdrop);
    sheet.appendChild(panel);
    document.body.appendChild(sheet);
    backdrop.addEventListener('click', closeSheet);
    close.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheet();
    });
    return sheet;
  }

  function closeSheet() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('pcard-sheet-open');
    window.setTimeout(function () { sheet.hidden = true; }, 300);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function openSheet(buy, productName) {
    var s = ensureSheet();
    var select = buy.querySelector('[data-pcard-select]');
    var wrap = s.querySelector('.pcard-sheet__options');
    wrap.textContent = '';
    Array.prototype.forEach.call(select.options, function (opt) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pcard-sheet__option';
      if (opt.disabled) b.disabled = true;
      if (opt.dataset.image) {
        var thumb = document.createElement('img');
        thumb.className = 'pcard-sheet__option-thumb';
        thumb.src = opt.dataset.image;
        thumb.alt = '';
        thumb.setAttribute('aria-hidden', 'true');
        b.appendChild(thumb);
      }
      var name = document.createElement('span');
      name.className = 'pcard-sheet__option-name';
      name.textContent = opt.text;
      var price = document.createElement('span');
      price.className = 'pcard-sheet__option-price';
      price.textContent = opt.dataset.price || '';
      b.appendChild(name);
      b.appendChild(price);
      if (opt.value === select.value && !opt.disabled) {
        b.classList.add('pcard-sheet__option--selected');
      }
      b.addEventListener('click', function () {
        /* SELECT-only: routing through the select's change event keeps id,
           price, chip and variant image in sync via §3; the card's full-width
           CTA performs the actual add */
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        closeSheet();
      });
      wrap.appendChild(b);
    });
    s.querySelector('.pcard-sheet__product').textContent = productName || '';
    lastFocus = document.activeElement;
    s.hidden = false;
    window.requestAnimationFrame(function () { s.classList.add('is-open'); });
    document.documentElement.classList.add('pcard-sheet-open');
    var first = wrap.querySelector('button:not([disabled])');
    if (first) first.focus();
  }

  /* Opened by the frosted format chip (mobile-only element — hidden on
     desktop, so no viewport guard needed). The cart CTA keeps its native
     submit behavior on every device. */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-pcard-chip]');
    if (!chip) return;
    var details = chip.closest('.pcard__details');
    var buy = details && details.querySelector('.pcard__buy');
    if (!buy || !buy.querySelector('[data-pcard-select]')) return;
    var card = chip.closest('.product-card');
    var titleEl = card && card.querySelector('.pcard__dialect');
    openSheet(buy, titleEl ? titleEl.textContent.trim() : '');
  });
})();


/* --------------------------------------------------------------------------
   5. SCROLL-REVEAL (Phase 4, UX-04)
   Shared IntersectionObserver reveal for [data-reveal] elements (scroll-story
   stops + La Nostra Storia rows). Toggles .is-visible; the fade itself is
   CSS-driven (custom.css section 26) and motion-gated, so no-JS and
   reduced-motion users see fully opaque content. No data-* value is read as
   HTML or a URL — the observer only toggles a class (T-04-03).
   -------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {
  var targets = document.querySelectorAll('[data-reveal]');
  if (!targets.length) return;
  if (!('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
  targets.forEach(function (el) { io.observe(el); });
});

/* --------------------------------------------------------------------------
   TICKER SCROLL-VELOCITY BOOST
   Each marquee (.ticker__track) speeds up while the page is being scrolled,
   then eases back to its base speed. Uses the Web Animations API playbackRate
   so the CSS marquee accelerates smoothly (no jump/restart). Reduced-motion
   tickers have animation:none, so getAnimations() is empty and this is a no-op.
   -------------------------------------------------------------------------- */
document.addEventListener('DOMContentLoaded', function () {
  var tracks = Array.prototype.slice.call(document.querySelectorAll('.ticker__track'));
  if (!tracks.length || typeof tracks[0].getAnimations !== 'function' || !('requestAnimationFrame' in window)) return;

  var BASE = 1;     // resting playback rate
  var MAX = 6;      // max speed multiplier during fast scrolls
  var GAIN = 3.5;   // px/ms of scroll velocity -> extra rate
  var EASE = 0.08;  // how fast the boost decays back to BASE

  var current = BASE;
  var target = BASE;
  var now0 = (window.performance && performance.now) ? performance.now() : Date.now();
  var lastY = window.pageYOffset || 0;
  var lastT = now0;
  var running = false;

  function setRate(rate) {
    for (var t = 0; t < tracks.length; t++) {
      var anims = tracks[t].getAnimations();
      for (var i = 0; i < anims.length; i++) anims[i].playbackRate = rate;
    }
  }

  function frame() {
    target += (BASE - target) * EASE;      // boost decays toward base
    current += (target - current) * 0.2;   // smooth follow
    setRate(current);
    if (Math.abs(current - BASE) > 0.01 || Math.abs(target - BASE) > 0.01) {
      requestAnimationFrame(frame);
    } else {
      current = BASE; target = BASE; setRate(BASE); running = false;
    }
  }

  window.addEventListener('scroll', function () {
    var now = (window.performance && performance.now) ? performance.now() : Date.now();
    var y = window.pageYOffset || 0;
    var dt = Math.max(now - lastT, 1);
    var v = Math.abs(y - lastY) / dt;      // px per ms
    lastY = y; lastT = now;
    var boosted = BASE + v * GAIN;
    if (boosted > MAX) boosted = MAX;
    if (boosted > target) target = boosted;
    if (!running) { running = true; requestAnimationFrame(frame); }
  }, { passive: true });
});

/* --------------------------------------------------------------------------
   6. FILTER CHIPS — ACTIVE PILL IN VIEW (shop + blog)
   The chip rows scroll horizontally on mobile (custom.css §25b / §31.6) and
   each pill is a full-reload link: after filtering, the row restarts at
   scrollLeft 0 and an active pill past the right edge is invisible. On load,
   centre the .active pill by adjusting the row's scrollLeft only — a
   scrollIntoView would also scroll the page vertically (html has
   scroll-behavior: smooth in base.css). Instant, not animated: this is state
   restoration, so it is also correct under reduced motion. Rows that
   overflow get .is-scrollable, which scopes the CSS edge-fade affordance to
   rows that actually scroll (desktop rows wrap and stay untouched).
   -------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {
  var rows = document.querySelectorAll('.collection-chips, .diario-chips, .ingredient-filter');
  Array.prototype.forEach.call(rows, function (row) {
    if (row.scrollWidth <= row.clientWidth) return;
    row.classList.add('is-scrollable');

    /* at-start / at-end drop the fade on edges with nothing beyond them
       (a fade over the last pill at end-of-row would read as a cut). */
    function updateEdges() {
      var max = row.scrollWidth - row.clientWidth;
      row.classList.toggle('at-start', row.scrollLeft <= 4);
      row.classList.toggle('at-end', row.scrollLeft >= max - 4);
    }

    var pill = row.querySelector('.ingredient-pill.active');
    if (pill) {
      var rowRect = row.getBoundingClientRect();
      var pillRect = pill.getBoundingClientRect();
      row.scrollLeft += (pillRect.left - rowRect.left) - (rowRect.width - pillRect.width) / 2;
    }
    updateEdges();
    row.addEventListener('scroll', updateEdges, { passive: true });
  });
});

/* --------------------------------------------------------------------------
   7. RECENSIONI HOME — CARD FIGMA DENTRO IL CAROSELLO JUDGE.ME (css §33)
   Lo slider ufficiale Judge.me resta (swipe, infinite scroll, slide del
   loro JS): si sostituisce solo il CONTENUTO di ogni card con il design
   Figma "Review Card" (nodo 2001:27). I dati NON si fetchano più: il
   widget costruisce le card client-side (media_carousel.js) e tiene gli
   oggetti recensione COMPLETI (created_at, tutte le pictures_urls,
   immagine prodotto) in window.jdgmCarouselMode[blockId].reviews — la
   card i-esima è reviews[data-card-index], quindi il match è 1:1 e
   nessuna recensione resta mai senza data (il vecchio doppio fetch
   divergeva: il widget aggiunge platform/primary_language/display_order
   alla query e l'endpoint serviva selezioni diverse). Ogni card è
   riscritta in place (classi slider conservate perché il loro JS
   continui a farsi i conti); un MutationObserver riprende card
   iniettate dopo e cloni dell'infinite scroll (già marcati .rev-card =
   skip, niente loop). Varianti cluster foto: 0 → immagine prodotto ·
   1 → singola · 2 → coppia sfalsata (-15°) · 3+ → ventaglio prime 3.
   Niente autoplay (scelta utente 2026-08-23): il timer di
   video_carousel.js legge data-transition-speed sul widget via
   MutationObserver e con "0" si ferma — il block ha transition_speed 0
   e qui c'è una guardia che riazzera l'attributo se qualcosa (es.
   jdgmHideArrows al resize) lo riportasse >0. Navigazione solo con le
   frecce custom .rev-nav sotto il carosello (css §32.5), che chiamano
   i global jdgmPreviousCard/jdgmNextCard del loro bundle.
   Se il JS Judge.me non parte le card restano le sue originali.
   -------------------------------------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {
  var widget = document.querySelector('.jdgm-cards-carousel');
  if (!widget) return;

  /* Glifi dal componente Figma: stella outline terracotta (on = anche
     riempita), doppie virgolette "parenthesis", freccia ↗. Colore via
     currentColor, così il CSS §33 decide. */
  var SVG_STAR =
    '<svg viewBox="0 0 14.74 14.08" width="15" height="14.4" fill="FILL" aria-hidden="true">' +
    '<path d="M7.36669 0.7L9.42669 4.87333L14.0334 5.54667L10.7 8.79333L11.4867 13.38L7.36669 11.2133L3.24669 13.38L4.03335 8.79333L0.70002 5.54667L5.30669 4.87333L7.36669 0.7Z" ' +
    'stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_STAR_ON = SVG_STAR.replace('FILL', 'currentColor');
  var SVG_STAR_OFF = SVG_STAR.replace('FILL', 'none');
  var SVG_QUOTE =
    '<svg viewBox="0 0 10.24 8" width="10.24" height="8" fill="currentColor" aria-hidden="true">' +
    '<path d="M0 5.30667C0 4.27555 0.373333 3.25333 1.12 2.24C1.88444 1.22667 2.82667 0.48 3.94667 0L4.85333 1.94667C4.53333 2.17778 4.22222 2.44444 3.92 2.74667C3.61778 3.03111 3.42222 3.34222 3.33333 3.68C3.63556 3.80445 3.92 4.06222 4.18667 4.45333C4.45333 4.82667 4.58667 5.24444 4.58667 5.70667C4.58667 6.25778 4.36444 6.78222 3.92 7.28C3.49333 7.76 2.95111 8 2.29333 8C1.65333 8 1.11111 7.75111 0.666667 7.25333C0.222222 6.75555 0 6.10667 0 5.30667ZM5.36 5.30667C5.36 4.27555 5.74222 3.25333 6.50667 2.24C7.27111 1.22667 8.21333 0.48 9.33333 0L10.24 1.94667C9.90222 2.17778 9.58222 2.44444 9.28 2.74667C8.97778 3.03111 8.78222 3.34222 8.69333 3.68C8.99556 3.80445 9.28 4.06222 9.54667 4.45333C9.83111 4.82667 9.97333 5.24444 9.97333 5.70667C9.97333 6.25778 9.75111 6.78222 9.30667 7.28C8.86222 7.76 8.32 8 7.68 8C7.04 8 6.48889 7.75111 6.02667 7.25333C5.58222 6.75555 5.36 6.10667 5.36 5.30667Z"/></svg>';
  var SVG_ARROW =
    '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" ' +
    'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M4.5 11.5L11.5 4.5M5.5 4.5h6v6"/></svg>';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text; /* mai innerHTML sui dati API */
    return n;
  }

  function imgEl(src, cls, alt) {
    var i = el('img', cls);
    i.src = src;
    i.alt = alt || '';
    i.loading = 'lazy';
    return i;
  }

  /* L'API serve i campi testuali già HTML-encoded (es. "d&#39;lavanda"):
     decodifica senza eseguire markup (textarea non interpreta tag). */
  var decoderTA = document.createElement('textarea');
  function decode(s) {
    if (!s || s.indexOf('&') === -1) return s || '';
    decoderTA.innerHTML = s.replace(/</g, '&lt;');
    return decoderTA.value;
  }

  /* Cluster foto in basso a destra (60px). Senza foto cliente si ripiega
     sull'immagine del prodotto recensito; senza nemmeno quella, niente. */
  function buildPics(review) {
    var pics = (review.pictures_urls || [])
      .map(function (p) { return p && (p.compact || p.small || p.huge || p.original); })
      .filter(Boolean);

    if (!pics.length) {
      var prod = review.product_variant_image_url;
      if (!prod) return null;
      var solo = el('div', 'rev-card__pics rev-card__pics--product');
      solo.appendChild(imgEl(
        prod + (prod.indexOf('?') > -1 ? '&' : '?') + 'width=180',
        'rev-card__pic rev-card__pic--front', decode(review.product_title)
      ));
      return solo;
    }

    var n = Math.min(pics.length, 3); /* oltre 3 si mostrano le prime 3 */
    var box = el('div', 'rev-card__pics rev-card__pics--' + n);
    /* ordine DOM dal fondo verso il fronte: niente z-index da gestire */
    if (n >= 3) box.appendChild(imgEl(pics[2], 'rev-card__pic rev-card__pic--back', ''));
    if (n >= 2) box.appendChild(imgEl(pics[1], 'rev-card__pic rev-card__pic--mid', ''));
    box.appendChild(imgEl(pics[0], 'rev-card__pic rev-card__pic--front', 'Foto della recensione'));
    return box;
  }

  function makeStars(rating) {
    var stars = el('div', 'rev-card__stars');
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', rating + ' stelle su 5');
    var glyphs = '';
    for (var i = 0; i < 5; i++) glyphs += i < rating ? SVG_STAR_ON : SVG_STAR_OFF;
    stars.innerHTML = glyphs; /* solo template statici */
    return stars;
  }

  function ratingOf(review) {
    return Math.max(0, Math.min(5, Math.round(review.rating) || 0));
  }

  /* Riscrive in place una card dello slider (originale o clone) col
     markup Figma. Le classi jdgm-media-card/jdgm-text-card RESTANO: il
     CSS del CDN Judge.me ci appende la larghezza della card (via
     --width-*); le sue regole sulle immagini interne sono neutralizzate
     dagli !important del §33. La card intera apre la modal recensione
     (§34) via il click delegato in fondo; Enter/Spazio equivalgono. */
  function restyleCard(item, review) {
    item.textContent = '';
    item.classList.add('rev-card');
    item.tabIndex = 0;
    item.setAttribute('role', 'button');
    /* label generica: la destinazione (lightbox o prodotto) si decide al
       click misurando il troncamento dal vivo */
    item.setAttribute('aria-label', 'Recensione di ' + (decode(review.reviewer_name) || 'un cliente'));

    var head = el('div', 'rev-card__head');
    head.appendChild(makeStars(ratingOf(review)));
    if (review.product_url) {
      var arrow = el('a', 'rev-card__arrow');
      arrow.href = review.product_url; /* stessa tab (feedback 2026-08-24) */
      arrow.setAttribute('aria-label', 'Vai al prodotto: ' + (decode(review.product_title) || 'recensito'));
      arrow.innerHTML = SVG_ARROW;
      head.appendChild(arrow);
    }
    item.appendChild(head);

    var quote = el('div', 'rev-card__quote');
    var markOpen = el('span', 'rev-card__mark');
    markOpen.innerHTML = SVG_QUOTE;
    var markClose = el('span', 'rev-card__mark rev-card__mark--close');
    markClose.innerHTML = SVG_QUOTE;
    quote.appendChild(markOpen);
    quote.appendChild(el('p', 'rev-card__text', decode(review.body)));
    quote.appendChild(markClose);
    item.appendChild(quote);

    var foot = el('div', 'rev-card__foot');
    var who = el('div', 'rev-card__who');
    var initial = (review.reviewer_initial || (review.reviewer_name || '?').charAt(0)).toUpperCase();
    var avatar = el('span', 'rev-card__avatar', initial);
    avatar.setAttribute('aria-hidden', 'true');
    who.appendChild(avatar);
    var names = el('div', 'rev-card__names');
    names.appendChild(el('span', 'rev-card__name', decode(review.reviewer_name) || 'Anonimo'));
    if (review.product_title) {
      if (review.product_url) {
        var prodLink = el('a', 'rev-card__product', decode(review.product_title));
        prodLink.href = review.product_url;
        names.appendChild(prodLink);
      } else {
        names.appendChild(el('span', 'rev-card__product', decode(review.product_title)));
      }
    }
    who.appendChild(names);
    foot.appendChild(who);
    var pics = buildPics(review);
    if (pics) foot.appendChild(pics);
    item.appendChild(foot);
  }

  /* ------------------------- MODAL RECENSIONE (css §34) ----------------
     Pattern del bottom-sheet §5: singleton, backdrop/×/Esc chiudono,
     scroll lock via classe su <html>, focus di ritorno alla card. */
  var modal = null;
  var modalLastFocus = null;
  var modalById = {}; /* uuid → recensione (anche fallback-DOM): i cloni
                         dello slider conservano data-review-id */

  function ensureModal() {
    if (modal) return modal;
    modal = el('div', 'rev-modal');
    modal.hidden = true;
    var backdrop = el('div', 'rev-modal__backdrop');
    var panel = el('div', 'rev-modal__panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.tabIndex = -1; /* il focus all'apertura va al dialog, non alla ×
                            (evita il focus ring sul tap; Tab raggiunge
                            comunque la ×) */
    var close = el('button', 'rev-modal__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Chiudi');
    /* La × vive nella sheetbar: su desktop la barra è alta zero e non
       posizionata, quindi la × (absolute) si aggancia al panel come
       prima; su mobile la barra è sticky in cima allo sheet (css §34)
       con la pill-maniglia, e la × si aggancia alla barra. */
    var sheetbar = el('div', 'rev-modal__sheetbar');
    sheetbar.appendChild(close);
    var body = el('div', 'rev-modal__body');
    panel.appendChild(sheetbar);
    panel.appendChild(body);
    modal.appendChild(backdrop);
    modal.appendChild(panel);
    document.body.appendChild(modal);
    backdrop.addEventListener('click', closeModal);
    close.addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeModal();
    });
    attachSheetDrag(panel);
    return modal;
  }

  /* Drag-to-dismiss del bottom sheet (solo layout mobile ≤749px, dove
     il pannello È uno sheet): trascinando verso il basso col contenuto
     già in cima (scrollTop 0) il pannello segue il dito; oltre ~90px al
     rilascio si chiude — closeModal toglie .is-open e la transition CSS
     lo accompagna da lì a translateY(100%) — altrimenti risale. Con
     delta ≤ 0 o partenza a metà scroll il gesto resta lo scroll interno
     (preventDefault solo nel ramo drag). */
  var sheetMQ = window.matchMedia('(max-width: 749px)');
  function attachSheetDrag(panel) {
    var startY = null;
    var delta = 0;
    var dragging = false;
    var fromTop = false;
    panel.addEventListener('touchstart', function (e) {
      if (!sheetMQ.matches) { startY = null; return; }
      startY = e.touches[0].clientY;
      delta = 0;
      dragging = false;
      /* dalla sheetbar (maniglia/×) si trascina sempre; dal contenuto
         solo se lo scroll interno è in cima */
      fromTop = panel.scrollTop <= 0 ||
        !!(e.target.closest && e.target.closest('.rev-modal__sheetbar'));
    }, { passive: true });
    panel.addEventListener('touchmove', function (e) {
      if (startY == null || !fromTop) return;
      delta = e.touches[0].clientY - startY;
      if (delta <= 0 && !dragging) return; /* scroll verso l'alto: suo */
      dragging = true;
      e.preventDefault();
      panel.style.transition = 'none';
      panel.style.transform = 'translateY(' + Math.max(0, delta) + 'px)';
    }, { passive: false });
    function release() {
      if (startY == null) return;
      startY = null;
      if (!dragging) return;
      dragging = false;
      panel.style.transition = '';
      panel.style.transform = '';
      if (delta > 90) closeModal();
    }
    panel.addEventListener('touchend', release);
    panel.addEventListener('touchcancel', release);
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('rev-modal-open');
    window.setTimeout(function () { modal.hidden = true; }, 250);
    if (modalLastFocus && modalLastFocus.focus) modalLastFocus.focus();
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return p(d.getDate()) + '/' + p(d.getMonth() + 1) + '/' + d.getFullYear();
  }

  /* Design dal mockup utente (2026-08-21): pannello a due colonne —
     a sinistra l'immagine grande (foto cliente, con thumbnails-galleria
     se più di una; senza foto, l'immagine del prodotto recensito), a
     destra stelle + nome prodotto, testo integrale tra le virgolette e
     footer avatar + nome + data con CTA terracotta piena al prodotto.
     Senza alcuna immagine: solo colonna testo. Su mobile impila. */
  function openReviewModal(review) {
    var m = ensureModal();
    var name = decode(review.reviewer_name) || 'Anonimo';
    m.querySelector('.rev-modal__panel')
      .setAttribute('aria-label', 'Recensione di ' + name);
    var body = m.querySelector('.rev-modal__body');
    body.textContent = '';

    var layout = el('div', 'rev-modal__layout');

    var pics = (review.pictures_urls || []).filter(Boolean);
    var prodImg = review.product_variant_image_url;
    var mainSrc = pics.length
      ? (pics[0].huge || pics[0].original || pics[0].compact)
      : (prodImg ? prodImg + (prodImg.indexOf('?') > -1 ? '&' : '?') + 'width=800' : null);
    if (mainSrc) {
      var media = el('div', 'rev-modal__media');
      var main = imgEl(mainSrc, 'rev-modal__main',
        pics.length ? 'Foto della recensione' : decode(review.product_title));
      media.appendChild(main);
      if (pics.length > 1) {
        var thumbs = el('div', 'rev-modal__thumbs');
        pics.forEach(function (pic, idx) {
          var b = el('button', 'rev-modal__thumb' + (idx === 0 ? ' is-active' : ''));
          b.type = 'button';
          b.setAttribute('aria-label', 'Foto ' + (idx + 1) + ' di ' + pics.length);
          b.appendChild(imgEl(pic.compact || pic.small || pic.huge, '', ''));
          b.addEventListener('click', function () {
            main.src = pic.huge || pic.original || pic.compact;
            var act = thumbs.querySelector('.is-active');
            if (act) act.classList.remove('is-active');
            b.classList.add('is-active');
          });
          thumbs.appendChild(b);
        });
        media.appendChild(thumbs);
      }
      layout.appendChild(media);
    }

    var content = el('div', 'rev-modal__content');

    /* Gerarchia (scelta utente 2026-08-23): nome prodotto come titolo in
       alto, stelle sotto, impilati — l'angolo della × resta pulito. */
    var head = el('div', 'rev-modal__head');
    if (review.product_title) {
      head.appendChild(el('h3', 'rev-modal__prodname', decode(review.product_title)));
    }
    head.appendChild(makeStars(ratingOf(review)));
    content.appendChild(head);

    var quote = el('div', 'rev-modal__quote');
    var markOpen = el('span', 'rev-card__mark');
    markOpen.innerHTML = SVG_QUOTE;
    var markClose = el('span', 'rev-card__mark rev-card__mark--close');
    markClose.innerHTML = SVG_QUOTE;
    quote.appendChild(markOpen);
    quote.appendChild(el('p', 'rev-modal__text', decode(review.body)));
    quote.appendChild(markClose);
    content.appendChild(quote);

    var foot = el('div', 'rev-modal__foot');
    var avatar = el('span', 'rev-card__avatar', (review.reviewer_initial || name.charAt(0)).toUpperCase());
    avatar.setAttribute('aria-hidden', 'true');
    foot.appendChild(avatar);
    var names = el('div', 'rev-modal__names');
    names.appendChild(el('span', 'rev-modal__name', name));
    var when = formatDate(review.created_at);
    if (when) names.appendChild(el('span', 'rev-modal__date', when));
    foot.appendChild(names);
    if (review.product_url) {
      /* stesso pattern del CTA della story strip: geometria e hover dei
         bottoni sito da .button--fill, qui solo il layout della modal */
      var cta = el('a', 'button button--fill rev-modal__cta', 'Vai al prodotto');
      cta.href = review.product_url;
      foot.appendChild(cta);
    }
    content.appendChild(foot);

    layout.appendChild(content);
    body.appendChild(layout);

    modalLastFocus = document.activeElement;
    m.hidden = false;
    window.requestAnimationFrame(function () { m.classList.add('is-open'); });
    document.documentElement.classList.add('rev-modal-open');
    m.querySelector('.rev-modal__panel').focus({ preventScroll: true });
  }

  var blockId = widget.getAttribute('data-jdgm-block-id');

  /* Gli oggetti recensione del widget stesso: media_carousel.js
     costruisce la card i-esima da reviews[i] e le stampa addosso
     data-card-index=i e data-review-id=uuid (i cloni dell'infinite
     scroll copiano gli attributi), quindi qui il match è esatto. */
  function widgetReviews() {
    var mode = window.jdgmCarouselMode;
    var m = mode && blockId && mode[blockId];
    return (m && m.reviews && m.reviews.length) ? m.reviews : null;
  }

  /* Ultima spiaggia (es. sample reviews in theme editor, dove
     jdgmCarouselMode non ha oggetti): i dati si leggono dal DOM della
     card PRIMA di svuotarla — stelle, testo, nome, prodotto e l'unica
     foto esposta (niente data né altre foto, ma design uniforme). */
  function reviewFromDom(item) {
    var bodyP = item.querySelector('.jdgm-text p');
    var name = item.querySelector('.jdgm-reviewer-name');
    var prodA = item.querySelector('.jdgm-product-name a');
    var img = item.querySelector('img');
    return {
      rating: item.querySelectorAll('.jdgm-star.jdgm--on').length,
      body: bodyP ? bodyP.textContent : '',
      reviewer_name: name ? name.textContent.trim() : '',
      product_title: prodA ? prodA.textContent.trim() : '',
      product_url: prodA ? prodA.getAttribute('href') : '',
      pictures_urls: img && img.src ? [{ compact: img.src }] : [],
      product_variant_image_url: null
    };
  }

  function reviewForCard(item, reviews) {
    if (reviews) {
      var idx = parseInt(item.getAttribute('data-card-index'), 10);
      var uuid = item.getAttribute('data-review-id');
      if (!isNaN(idx) && reviews[idx] && reviews[idx].uuid === uuid) return reviews[idx];
      for (var i = 0; i < reviews.length; i++) {
        if (reviews[i].uuid === uuid) return reviews[i];
      }
    }
    return reviewFromDom(item);
  }

  function restyleAll() {
    var items = widget.querySelectorAll('.jdgm-card:not(.rev-card)');
    if (!items.length) return;
    var reviews = widgetReviews();
    for (var i = 0; i < items.length; i++) {
      var review = reviewForCard(items[i], reviews);
      modalById[items[i].getAttribute('data-review-id')] = review;
      restyleCard(items[i], review);
    }
  }

  /* Click con UNA SOLA regola (scelta utente 2026-08-21: il click
     condizionale — modal solo per testi troncati o foto — sembrava un
     errore): la card apre SEMPRE la modal recensione §34; il prodotto
     resta raggiungibile da freccia ↗, nome prodotto e CTA nella modal.
     stopImmediatePropagation su OGNI ramo: il handler lightbox di
     Judge.me (attachCarouselLightbox, bubble sul widget, registrato
     DOPO il nostro perché il bundle è async) fa preventDefault su
     qualunque click di card — dirottava perfino la freccia ↗ — e non
     deve mai scattare. */
  var lastPointerDown = null;
  widget.addEventListener('pointerdown', function (e) {
    lastPointerDown = { x: e.clientX, y: e.clientY };
  }, true);
  widget.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.rev-card');
    if (!card) return;
    if (e.target.closest && e.target.closest('a')) {
      e.stopImmediatePropagation(); /* il link naviga, niente lightbox */
      return;
    }
    if (lastPointerDown &&
        Math.abs(e.clientX - lastPointerDown.x) + Math.abs(e.clientY - lastPointerDown.y) > 8) {
      e.stopImmediatePropagation(); /* era uno swipe dello slider */
      return;
    }
    var review = modalById[card.getAttribute('data-review-id')];
    if (!review) return;
    e.stopImmediatePropagation();
    openReviewModal(review);
  });
  widget.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var card = e.target.closest && e.target.closest('.rev-card');
    if (!card || e.target !== card) return;
    e.preventDefault();
    /* stesso percorso del click (guardia swipe azzerata) */
    lastPointerDown = null;
    card.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
  });

  /* Le card arrivano async dal JS di Judge.me (build iniziale + cloni
     dell'infinite scroll): si osserva da subito, il filtro
     :not(.rev-card) evita il loop osservatore. */
  restyleAll();
  var mo = new MutationObserver(restyleAll);
  mo.observe(widget, { childList: true, subtree: true });

  /* Guardia no-autoplay: il timer di video_carousel.js segue
     data-transition-speed (suo MutationObserver: "0"/assente = stop).
     Il block ha già transition_speed 0, ma jdgmHideArrows (ResizeObserver
     del loro bundle) riscrive l'attributo dalle settings: se mai
     tornasse >0, qui si riazzera e il loro observer spegne il timer. */
  if (widget.getAttribute('data-transition-speed') !== '0') {
    widget.setAttribute('data-transition-speed', '0');
  }
  var moSpeed = new MutationObserver(function () {
    if (widget.getAttribute('data-transition-speed') !== '0') {
      widget.setAttribute('data-transition-speed', '0');
    }
  });
  moSpeed.observe(widget, { attributes: true, attributeFilter: ['data-transition-speed'] });

  /* Frecce custom sotto il carosello, centrate (css §32.5). Le frecce
     laterali Judge.me sono nascoste via CSS; queste chiamano i global
     del loro bundle, così slide, riallineamento del nastro e infinite
     scroll restano i loro. */
  /* ViewBox quadrato, glifo con centro a x=11.5 (mezzo px verso la
     punta = centratura ottica nel cerchio); il next è specchiato via
     scaleX in CSS, quindi il bias segue sempre la punta. Stroke 1.5:
     resi a 20px sono ~1.25px visivi, il peso leggero del design
     originale (2.5 qui diventava ~2.1px — troppo bold, feedback
     2026-08-24). */
  var SVG_CHEVRON =
    '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" ' +
    'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M14.8 5.5L8.2 12L14.8 18.5"/></svg>';
  function navBtn(dir, label) {
    var b = el('button', 'rev-nav__btn rev-nav__btn--' + dir);
    b.type = 'button';
    b.setAttribute('aria-label', label);
    b.innerHTML = SVG_CHEVRON; /* solo template statico */
    b.addEventListener('click', function () {
      var go = dir === 'prev' ? window.jdgmPreviousCard : window.jdgmNextCard;
      if (typeof go === 'function') go(blockId);
    });
    return b;
  }
  var nav = el('div', 'rev-nav');
  nav.appendChild(navBtn('prev', 'Recensione precedente'));
  nav.appendChild(navBtn('next', 'Recensione successiva'));
  widget.appendChild(nav);
});
